// extracted by mini-css-extract-plugin
export default {"button":"Button_button__YFab9","disabled":"Button_disabled__1iuQn","bck":"Button_bck__ri4Aw"};